module.exports = __webpack_public_path__ + "img/SchreitenderXVI.8d59d20e.jpg";